<!-- //
数据服务-API接口审批
@auth xuyd
@date 2024-05-03
//-->
<template>
  <page-layout layout="C">
    <div class="layout-function flex-row flex-valign-center flex-halign-between" style="">
      <div class="flex-row flex-valign-center">
        <span>{{ form.apiComment }}（{{ form.apiName }}）</span>
        <el-divider direction="vertical"/>
        <dict-tag v-if="form.resolve"
                  :options="{type: 'tag'}"
                  dictType="ONLINE_STATUS"
                  :value="form.onlineStatus"/>
        <dict-tag v-else
                  :options="{type: 'tag'}"
                  dictType="API_STATUS"
                  :value="form.apiStatus"/>
      </div>
      <div class="flex-row flex-valign-center">
      </div>
    </div>
    <div class="layout-result" style="height: 100%;margin-top: 5px;">
      <DetailBasic :form-data="form" />
      <el-divider direction="horizontal"/>
      <el-form @submit.native.prevent ref="refForm" :model="approveForm" size="small" label-width="120px" class="form">
        <el-form-item>
          <span slot="label" class="title">审批意见</span>
          <el-input type="textarea" placeholder="审批意见"
                    v-model="form.approveResult"
                    maxlength="255"
                    clearable
                    style="width: 100%"
                    show-word-limit />
        </el-form-item>
      </el-form>
      <div class="flex-row flex-halign-center">
        <el-button size="small" type="primary" @click="handleResolve" :loading="loading">通过</el-button>
        <el-button size="small" type="danger" @click="handleResolveAndOnline" :loading="onlineLoading">审批并上线</el-button>
        <el-button size="small" type="warning" @click="handleReject" :loading="loading">驳回</el-button>
        <el-button size="small" @click="handleCancel">返回</el-button>
      </div>
    </div>
  </page-layout>
</template>

<script>

import ApiDesignApi from '@/api/datasvc/apiDesign.api.js';
import DetailBasic from '../design/detail-basic';

export default {
  name: 'ViewApiDesignDetail',
  components: {DetailBasic},
  dictTypes: [
    {dictType: 'API_STATUS', dataType: Number},
    {dictType: 'ONLINE_STATUS', dataType: Number},
  ],
  data() {
    return {
      loading: false,
      onlineLoading: false,
      form: {
        id: null,
      },
      approveForm: {
        id: null,
        approveCmdType: null, // 通过/驳回
        approveResult: null,  // 审批意见
      }
    }
  },
  created() {
    this.form.id = this.$route.query.id;
    this.approveForm.id = this.$route.query.id;
    this.getApiInfo();
  },
  methods: {
    getApiInfo() {
      ApiDesignApi.getInfo(this.form.id).then(resp => {
        this.form = resp.data;
      });
    },

    handleResolve() {
      this.$modal.confirm(`确定要审批通过吗？`).then(() => {
        this.loading = true
        return ApiDesignApi.approveResolve(this.approveForm)
      }).then(resp => {
        this.loading = false
        this.$modal.msgSuccess("审批通过成功");
        this.$router.back();
      }).catch(() =>{
        this.loading = false
      })
    },
    handleReject() {
      this.$modal.confirm(`确定要驳回吗？`).then(() => {
        this.loading = true
        return ApiDesignApi.approveReject(this.approveForm)
      }).then(resp => {
        this.loading = false
        this.$modal.msgSuccess("审批驳回完成");
        this.$router.back();
      }).catch(() =>{
        this.loading = false
      })
    },

    handleResolveAndOnline() {
      this.$modal.confirm(`确定要审批通过并上线吗？`).then(() => {
        this.onlineLoading = true
        return ApiDesignApi.approveResolveAndOnline(this.approveForm)
      }).then(resp => {
        this.onlineLoading = false
        this.$modal.msgSuccess("审批并上线成功");
        this.$router.back();
      }).catch(() =>{
        this.onlineLoading = false
      })
    },
    handleCancel() {
      this.$router.back();
    },

  }
}
</script>

<style lang="less" scoped>
</style>
